import React from 'react';
import styled from 'styled-components';
import useScreenQuery from '../../hooks/useScreenQuery';
import PlayupThemeProvider from '../../themes/PlayupThemeProvider';

interface ErrorMessageProps {
	textAlign?: 'center' | 'left';
	children: React.ReactNode;
}
const ErrorMessage: React.FC<ErrorMessageProps> = ({ children, textAlign = 'center' }) => {
	const { isSmall } = useScreenQuery();
	return (
		<PlayupThemeProvider>
			<ErrorText textAlign={textAlign} isSmallScreen={isSmall}>
				{children}
			</ErrorText>
		</PlayupThemeProvider>
	);
};

export default ErrorMessage;

export const ErrorText = styled.div<{ isSmallScreen: boolean; textAlign: 'left' | 'center' }>`
	margin-top: ${({ isSmallScreen }) => (isSmallScreen ? '5px' : '10px')};
	margin-bottom: ${({ isSmallScreen }) => (isSmallScreen ? '5px' : '10px')};
	color: ${({ theme }) => theme.colors.danger};
	font-size: ${({ isSmallScreen }) => (isSmallScreen ? '14px' : '18px')};
	text-align: ${({ textAlign }) => textAlign};
`;
